export class StoreLocator {
    // Constructor
    constructor( ele ) {
        this.locator = ele;

        // Script for store locator page
        this.tabs = this.locator.querySelectorAll('.tab-title');
        this.tabsContainer = this.locator.querySelector('.tab-titles');
        this.tabsContent = this.locator.querySelectorAll('.tab-content');

        // If we have a tab container, add the listener
        if ( this.tabsContainer ) this.tabsContainer.addEventListener('click', this.changeTab.bind(this));

        // If the page has a buy-now in the search, open that tab by default
        const search = window.location.search;
        if ( search.includes('buy-now') ) {
            this.switchToBuyNowTab();
            // Track a GA4 event for the tab change
            analytics.track.client("buynow_tab_load", { event_category: "buy_now" }, ["googleAnalytics"]);
        }
    }

    // Change the subject
    changeTab( e ) {
        e.preventDefault();
        const clicked = e.target.closest('.tab-title');
        if(!clicked) return;
        // Remove active class
        this.tabs.forEach(t => t.classList.remove('tab-active'));
        this.tabsContent.forEach(c => c.classList.remove('tab-content-active'));
        // Active Tab
        clicked.classList.add(('tab-active'));
        // Active Content
        this.locator.querySelector(`.tab-content-${clicked.dataset.title}`).classList.add('tab-content-active');

        // Track a GA4 event for the tab change
        analytics.track.client("storelocator_tab_click", { event_category: "buy_now", event_label: clicked.dataset.title }, ["googleAnalytics"]);
    }

    // Switch to the buy now tab without a click
    switchToBuyNowTab() {
        // Get the two tabs
        const buyNowTab = this.locator.querySelector('.tab-title[data-title="buy-now"]');
        const storeLocatorTab = this.locator.querySelector('.tab-title[data-title="store-locator"]');
        // Get the two content areas
        const buyNowContent = this.locator.querySelector('.tab-content-buy-now');
        const storeLocatorContent = this.locator.querySelector('.tab-content-store-locator');
        // Remove active class from store locator
        storeLocatorTab.classList.remove('tab-active');
        storeLocatorContent.classList.remove('tab-content-active');
        // Add active class to buy now
        buyNowTab.classList.add('tab-active');
        buyNowContent.classList.add('tab-content-active');
    }

}